export const isAuthenticated = (state) => {
    if (state.auth.auth.idToken) return true;
    return false;
};

export const isVerified = (state) => {
    if (state.auth?.auth?.isVerified) return true;
    return false;
};
